import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="pipeline-schedule"
// Shows/hides scheduling sub-options (daily time picker, N-hourly N selector)
// based on the currently selected schedule_mode radio.
export default class extends Controller {
  static targets = ["dailyOptions", "everyNHoursOptions", "radio"]

  connect() {
    this.update()
  }

  update() {
    const selected = this.radioTargets.find((r) => r.checked)
    const mode = selected ? selected.value : "off"

    this.toggle(this.dailyOptionsTarget, mode === "daily")
    this.toggle(this.everyNHoursOptionsTarget, mode === "every_n_hours")
  }

  toggle(el, visible) {
    if (visible) {
      el.classList.remove("hidden")
    } else {
      el.classList.add("hidden")
    }
  }
}
